(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purus-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class PurusReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.viewport = this.querySelector('[data-review-viewport]');
      this.track = this.querySelector('[data-review-track]');
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.previousButton = this.querySelector('[data-review-previous]');
      this.nextButton = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.progress = this.querySelector('[data-review-progress]');

      if (!this.viewport || !this.track || !this.cards.length) return;

      this.isInitialized = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = null;

      this.handleScroll = () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.updateControls();
        });
      };

      this.handleResize = () => this.updateControls();
      this.handlePrevious = () => this.goTo(this.getCurrentIndex() - 1);
      this.handleNext = () => this.goTo(this.getCurrentIndex() + 1);

      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);

      this.updateControls();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.viewport?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);

      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.isInitialized = false;
    }

    cardLeft(card) {
      return card.offsetLeft - this.track.offsetLeft;
    }

    getCurrentIndex() {
      const currentLeft = this.viewport.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(this.cardLeft(card) - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    goTo(index) {
      const targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));
      const targetCard = this.cards[targetIndex];
      if (!targetCard) return;

      this.viewport.scrollTo({
        left: this.cardLeft(targetCard),
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const currentScroll = Math.max(0, this.viewport.scrollLeft);
      const currentIndex = this.getCurrentIndex();
      const firstCardWidth = this.cards[0]?.getBoundingClientRect().width || this.viewport.clientWidth;
      const visibleCount = Math.max(1, Math.round(this.viewport.clientWidth / firstCardWidth));
      const lastVisibleIndex = Math.min(this.cards.length - 1, currentIndex + visibleCount - 1);
      const atStart = currentScroll <= 2;
      const atEnd = maximumScroll - currentScroll <= 2;

      if (this.position) {
        this.position.textContent = visibleCount > 1
          ? `${currentIndex + 1}–${lastVisibleIndex + 1}`
          : String(currentIndex + 1);
      }
      if (this.previousButton) this.previousButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;

      if (this.progress) {
        const visibleWidth = Math.min(1, this.viewport.clientWidth / this.viewport.scrollWidth);
        const travelled = maximumScroll > 0 ? (currentScroll / maximumScroll) * (1 - visibleWidth) : 0;
        this.progress.style.width = `${Math.min(1, visibleWidth + travelled) * 100}%`;
      }
    }
  }

  if (!customElements.get('purus-review-carousel')) {
    customElements.define('purus-review-carousel', PurusReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
